// import { Component } from '@theme/component';
// import { trapFocus, removeTrapFocus } from '@theme/focus';
// import { onAnimationEnd } from '@theme/utilities';

// /**
//  * A custom element that manages the main menu drawer.
//  *
//  * @typedef {object} Refs
//  * @property {HTMLDetailsElement} details - The details element.
//  *
//  * @extends {Component<Refs>}
//  */
// class HeaderDrawer extends Component {
//   requiredRefs = ['details'];

//   connectedCallback() {
//     super.connectedCallback();

//     this.addEventListener('keyup', this.#onKeyUp);
//     this.#setupAnimatedElementListeners();
//   }

//   disconnectedCallback() {
//     super.disconnectedCallback();
//     this.removeEventListener('keyup', this.#onKeyUp);
//   }

//   /**
//    * Close the main menu drawer when the Escape key is pressed
//    * @param {KeyboardEvent} event
//    */
//   #onKeyUp = (event) => {
//     if (event.key !== 'Escape') return;

//     this.#close(this.#getDetailsElement(event));
//   };

//   /**
//    * @returns {boolean} Whether the main menu drawer is open
//    */
//   get isOpen() {
//     return this.refs.details.hasAttribute('open');
//   }

//   /**
//    * Get the closest details element to the event target
//    * @param {Event | undefined} event
//    * @returns {HTMLDetailsElement}
//    */
//   #getDetailsElement(event) {
//     if (!(event?.target instanceof Element)) return this.refs.details;

//     return event.target.closest('details') ?? this.refs.details;
//   }

//   /**
//    * Toggle the main menu drawer
//    */
//   toggle() {
//     return this.isOpen ? this.close() : this.open();
//   }

//   /**
//    * Open the closest drawer or the main menu drawer
//    * @param {Event} [event]
//    */
//   open(event) {
//     const details = this.#getDetailsElement(event);
//     const summary = details.querySelector('summary');

//     if (!summary) return;

//     summary.setAttribute('aria-expanded', 'true');

//     this.preventInitialAccordionAnimations(details);
//     requestAnimationFrame(() => {
//       details.classList.add('menu-open');
//       setTimeout(() => {
//         trapFocus(details);
//       }, 0);
//     });
//   }

//   /**
//    * Go back or close the main menu drawer
//    * @param {Event} [event]
//    */
//   back(event) {
//     this.#close(this.#getDetailsElement(event));
//   }

//   /**
//    * Close the main menu drawer
//    */
//   close() {
//     this.#close(this.refs.details);
//   }

//   /**
//    * Close the closest menu or submenu that is open
//    *
//    * @param {HTMLDetailsElement} details
//    */
//   #close(details) {
//     const summary = details.querySelector('summary');

//     if (!summary) return;

//     summary.setAttribute('aria-expanded', 'false');
//     details.classList.remove('menu-open');

//     onAnimationEnd(details, () => {
//       reset(details);
//       if (details === this.refs.details) {
//         removeTrapFocus();
//         const openDetails = this.querySelectorAll('details[open]:not(accordion-custom > details)');
//         openDetails.forEach(reset);
//       } else {
//         setTimeout(() => {
//           trapFocus(this.refs.details);
//         }, 0);
//       }
//     });
//   }

//   /**
//    * Attach animationend event listeners to all animated elements to remove will-change after animation
//    * to remove the stacking context and allow submenus to be positioned correctly
//    */
//   #setupAnimatedElementListeners() {
//     /**
//      * @param {AnimationEvent} event
//      */
//     function removeWillChangeOnAnimationEnd(event) {
//       const target = event.target;
//       if (target && target instanceof HTMLElement) {
//         target.style.setProperty('will-change', 'unset');
//         target.removeEventListener('animationend', removeWillChangeOnAnimationEnd);
//       }
//     }
//     const allAnimated = this.querySelectorAll('.menu-drawer__animated-element');
//     allAnimated.forEach((element) => {
//       element.addEventListener('animationend', removeWillChangeOnAnimationEnd);
//     });
//   }

//   /**
//    * Temporarily disables accordion animations to prevent unwanted transitions when the drawer opens.
//    * Adds a no-animation class to accordion content elements, then removes it after 100ms to
//    * re-enable animations for user interactions.
//    * @param {HTMLDetailsElement} details - The details element containing the accordions
//    */
//   preventInitialAccordionAnimations(details) {
//     const content = details.querySelectorAll('accordion-custom .details-content');

//     content.forEach((element) => {
//       if (element instanceof HTMLElement) {
//         element.classList.add('details-content--no-animation');
//       }
//     });
//     setTimeout(() => {
//       content.forEach((element) => {
//         if (element instanceof HTMLElement) {
//           element.classList.remove('details-content--no-animation');
//         }
//       });
//     }, 100);
//   }
// }

// if (!customElements.get('header-drawer')) {
//   customElements.define('header-drawer', HeaderDrawer);
// }

// /**
//  * Reset an open details element to its original state
//  *
//  * @param {HTMLDetailsElement} element
//  */
// function reset(element) {
//   element.classList.remove('menu-open');
//   element.removeAttribute('open');
//   element.querySelector('summary')?.setAttribute('aria-expanded', 'false');
// }

import { Component } from "@theme/component";
import { trapFocus, removeTrapFocus } from "@theme/focus";
import { onAnimationEnd } from "@theme/utilities";

/**
 * A custom element that manages the main menu drawer.
 *
 * @typedef {object} Refs
 * @property {HTMLDetailsElement} details - The details element.
 *
 * @extends {Component<Refs>}
 */
class HeaderDrawer extends Component {
  requiredRefs = ["details"];

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener("keyup", this.#onKeyUp);
    this.#setupAnimatedElementListeners();
    this.#sanearEstadoInicial();
  }

  /**
   * ARREGLO 28 AGO — el menu se quedaba pegado mostrando la X
   *
   * El icono del boton no lo decide el JS, lo decide el CSS de
   * snippets/header-drawer.liquid:
   *
   *     details:not([open]) ... .header-drawer-icon--close { display: none }
   *     details[open]       ... .header-drawer-icon--open  { display: none }
   *
   * O sea: si se ve la X es porque el <details> tiene el atributo "open".
   *
   * El panel y el atributo pueden desincronizarse, porque quien quita el
   * atributo es reset(), y reset() vive DENTRO del onAnimationEnd de #close.
   * Si esa promesa no se resuelve (una animacion que no termina, la pestana
   * restaurada por el navegador al volver atras o al recargar, o un script de
   * una app que toca el details), el panel se cierra pero el atributo se
   * queda puesto. A partir de ahi cada toque va con un paso de retraso: el
   * primero "cierra" algo que ya estaba cerrado y no pasa nada visible.
   *
   * Esto lo comprueba al cargar: si hay "open" pero no hay "menu-open", es
   * que el usuario abrio el cajon antes de que este archivo se ejecutara.
   * En ese caso se termina de abrir en condiciones.
   */
  #sanearEstadoInicial() {
    const details = this.refs.details;
    if (!details) return;

    if (
      !details.hasAttribute("open") ||
      details.classList.contains("menu-open")
    )
      return;

    // Llegados aqui: el <details> esta abierto pero el JS aun no habia puesto
    // .menu-open. Eso solo puede pasar de una forma: el usuario toco el boton
    // ANTES de que este archivo se ejecutara, y el navegador hizo el toggle
    // nativo del <summary> por su cuenta.
    //
    // Gracias a la regla header-drawer:not(:defined) de
    // snippets/header-drawer.liquid, en ese momento el panel SI se estaba
    // viendo. Como ahora el componente toma el control, :not(:defined) deja de
    // aplicarse, asi que hay que rematar la apertura o el panel desapareceria
    // de golpe delante del usuario.
    //
    // Antes esto hacia reset(): cerraba el estado. Funcionaba para dejar el
    // icono bien, pero se comia el toque del usuario. Asi se respeta.
    this.open();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("keyup", this.#onKeyUp);
  }

  /**
   * Close the main menu drawer when the Escape key is pressed
   * @param {KeyboardEvent} event
   */
  #onKeyUp = (event) => {
    if (event.key !== "Escape") return;

    this.#close(this.#getDetailsElement(event));
  };

  /**
   * @returns {boolean} Whether the main menu drawer is open
   */
  get isOpen() {
    return this.refs.details.hasAttribute("open");
  }

  /**
   * Get the closest details element to the event target
   * @param {Event | undefined} event
   * @returns {HTMLDetailsElement}
   */
  #getDetailsElement(event) {
    if (!(event?.target instanceof Element)) return this.refs.details;

    return event.target.closest("details") ?? this.refs.details;
  }

  /**
   * Toggle the main menu drawer
   */
  toggle() {
    return this.isOpen ? this.close() : this.open();
  }

  /**
   * Open the closest drawer or the main menu drawer
   * @param {Event} [event]
   */
  open(event) {
    const details = this.#getDetailsElement(event);
    const summary = details.querySelector("summary");

    if (!summary) return;

    summary.setAttribute("aria-expanded", "true");

    this.preventInitialAccordionAnimations(details);
    requestAnimationFrame(() => {
      details.classList.add("menu-open");
      setTimeout(() => {
        trapFocus(details);
      }, 0);
    });
  }

  /**
   * Go back or close the main menu drawer
   * @param {Event} [event]
   */
  back(event) {
    this.#close(this.#getDetailsElement(event));
  }

  /**
   * Close the main menu drawer
   */
  close() {
    this.#close(this.refs.details);
  }

  /**
   * Close the closest menu or submenu that is open
   *
   * @param {HTMLDetailsElement} details
   */
  #close(details) {
    const summary = details.querySelector("summary");

    if (!summary) return;

    summary.setAttribute("aria-expanded", "false");
    details.classList.remove("menu-open");

    // ARREGLO 28 AGO — antes esto era un onAnimationEnd pelado. onAnimationEnd
    // hace Promise.allSettled sobre details.getAnimations({subtree:true}): si
    // UNA sola de esas animaciones no termina nunca, reset() no se ejecuta y
    // el atributo "open" se queda puesto para siempre. De ahi la X pegada.
    //
    // Ahora se ejecuta lo que ocurra primero: el fin de las animaciones o un
    // tope de 400 ms. La animacion del cajon dura 0,2s
    // (--drawer-animation-speed en snippets/theme-styles-variables.liquid),
    // asi que 400 ms deja el doble de margen y no corta nada.
    let yaCerrado = false;

    const finalizarCierre = () => {
      if (yaCerrado) return;
      yaCerrado = true;

      reset(details);

      if (details === this.refs.details) {
        removeTrapFocus();
        const openDetails = this.querySelectorAll(
          "details[open]:not(accordion-custom > details)",
        );
        openDetails.forEach(reset);
      } else {
        setTimeout(() => {
          trapFocus(this.refs.details);
        }, 0);
      }
    };

    onAnimationEnd(details, finalizarCierre);
    setTimeout(finalizarCierre, 400);
  }

  /**
   * Attach animationend event listeners to all animated elements to remove will-change after animation
   * to remove the stacking context and allow submenus to be positioned correctly
   */
  #setupAnimatedElementListeners() {
    /**
     * @param {AnimationEvent} event
     */
    function removeWillChangeOnAnimationEnd(event) {
      const target = event.target;
      if (target && target instanceof HTMLElement) {
        target.style.setProperty("will-change", "unset");
        target.removeEventListener(
          "animationend",
          removeWillChangeOnAnimationEnd,
        );
      }
    }
    const allAnimated = this.querySelectorAll(".menu-drawer__animated-element");
    allAnimated.forEach((element) => {
      element.addEventListener("animationend", removeWillChangeOnAnimationEnd);
    });
  }

  /**
   * Temporarily disables accordion animations to prevent unwanted transitions when the drawer opens.
   * Adds a no-animation class to accordion content elements, then removes it after 100ms to
   * re-enable animations for user interactions.
   * @param {HTMLDetailsElement} details - The details element containing the accordions
   */
  preventInitialAccordionAnimations(details) {
    const content = details.querySelectorAll(
      "accordion-custom .details-content",
    );

    content.forEach((element) => {
      if (element instanceof HTMLElement) {
        element.classList.add("details-content--no-animation");
      }
    });
    setTimeout(() => {
      content.forEach((element) => {
        if (element instanceof HTMLElement) {
          element.classList.remove("details-content--no-animation");
        }
      });
    }, 100);
  }
}

if (!customElements.get("header-drawer")) {
  customElements.define("header-drawer", HeaderDrawer);
}

/**
 * Reset an open details element to its original state
 *
 * @param {HTMLDetailsElement} element
 */
function reset(element) {
  element.classList.remove("menu-open");
  element.removeAttribute("open");
  element.querySelector("summary")?.setAttribute("aria-expanded", "false");
}
